// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"349":"email-editor","552":"chartjs"}[chunkId] || chunkId) + "-" + {"14":"426c9ef08d410dd72f8e","349":"6729def517f70c4fa9cd","492":"21ba5661655cf8786dbe","552":"f50284f324aeb49d8bd8","818":"afa8b48e365da4bc35d0"}[chunkId] + ".chunk.js";
};